import { bankActionSelectors as selector } from "../Selectors/index";
import { openSnackbar } from "./snackbarActions";
import BankService from "../../Service/Payments/bank.service";

export const getBank = (Bank) => {
  return {
    type: selector.GET_BANK,
    payload: Bank,
  };
};

export const fetchBank = () => {
  return async (dispatch) => {
    try {
      const res = await BankService.getAll();
      dispatch(getBank(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
};
